import "./leaderboard.less";
import {isOverflown} from "utils/helpers";
import { PropsWithChildren, useEffect, useLayoutEffect, useRef, useState } from "react";

interface Props {
  className?: string
  onIsOverflowingChanged?: (isOverflowing: boolean) => void
}

export default function Leaderboard(props: PropsWithChildren<Props>) {
  let className = "leaderboard";
  if (props.className) {
    className += " " + props.className
  }
  const ref = useRef<HTMLDivElement>(null);
  
  function computeIsOverflowing() {
    let overflowing = false;
    if (ref.current) {
      overflowing = isOverflown(ref.current)
    }
    // console.log({overflowing})
    return overflowing
  }
  
  const [isOverflowing, setIsOverflowing] = useState(() => computeIsOverflowing())

  useLayoutEffect(() => {
    function change() {
      setIsOverflowing(computeIsOverflowing())
    }

    change()
    window.addEventListener("resize", change)
    return () => {
      window.removeEventListener("resize", change)
    }
  }, [props.children])
  
  useEffect(() => {
    if (props.onIsOverflowingChanged) {
      props.onIsOverflowingChanged(isOverflowing)
    }
  }, [isOverflowing])
  
  return <div className={className} ref={ref}>
    {props.children}
  </div>
}